// extracted by mini-css-extract-plugin
export default {"btn":"PortReqestRejected_btn__wZskN"};